import gsap from 'gsap';
import { device } from '@/plugins/device';

const animationOptionsDefaults = {
  duration: 0.75,
  delay: 0.25
};
export default {
  install(Vue) {
    Vue.directive('animate-in', {
      inserted(el, binding) {
        const observeOptions = {
          root: null,
          threshold: 0.1
        };
        const options = binding.value || {};
        const animationOptions = {
          ...animationOptionsDefaults,
          ...options,
          delay: animationOptionsDefaults.delay + (options.delay || 0)
        };
        if (device.intersectionObserver) {
          gsap.set(el, { opacity: 0, y: '50%' });
          let observer = new IntersectionObserver(e => {
            const intersection = e[0];
            if (!intersection || intersection.intersectionRatio <= 0.1) return;
            animateIn(el, animationOptions);
          }, observeOptions);
          observer.observe(el);
        }
      }
    });

    function animateIn(el, options) {
      gsap.to(el, { y: '0%', opacity: 1, ...options });
    }
  }
};
